<template>
  <div class="d-flex justify-content-end">
    <b-button v-if="propMensalista === null" 
              id="addItens"
              v-b-modal.novoMensalista
              class="mb-2"
              :variant="propComponentePai == 'OrdemServicoMensalista' ? 'outline-primary' : 'primary'"
              @click="showModal">
      <IconSvg v-if="propComponentePai != 'OrdemServicoMensalista'"
               class="icon-add-new add-icon"
               icon="add" />
      {{ propComponentePai != 'OrdemServicoMensalista' ? 'Novo Mensalista' : 'Adicionar novo' }}
    </b-button>
    <div v-if="propMensalista != null"
         @click="showModal">
      <icon-svg icon="simplePencil"
                class="icon-simple-pecil ml-3" />
    </div>
    <b-modal :id="propMensalista ? `novoMensalista${propMensalista.mensalista_id}` : 'novoMensalista'"
             centered
             size="xl"
             :title="propMensalista ? 'Editar Mensalista' : 'Salvar Mensalista'"
             header-bg-variant="secondary"
             header-text-variant="white"
             hide-footer>
      <Form class="p-2"
            @submit.prevent="salvarMensalista">
        <div class="row">
          <div class="form-group col-3">
            <label for="cpf-cnpj">CNPJ ou CPF <strong class="input-live-help">*</strong></label>
            <b-form-input id="cpf-cnpj"
                          v-model="mensalista.cpf_cnpj"
                          v-mask="['999.999.999-99', '99.999.999/9999-99']" 
                          type="text"
                          autocomplete="off"
                          class="form-control"
                          :state="cpfState"
                          required                  
                          @blur="validaCPF" />
            <b-form-invalid-feedback id="input-live-feedback">
              CPF ou CNPJ já cadastrado
            </b-form-invalid-feedback>
          </div>
          <div class="form-group col-5">
            <label for="nome-solicitante">Nome do solicitante <strong class="input-live-help">*</strong></label>
            <input id="nome-solicitante"
                   v-model="mensalista.nome_empresa"
                   required
                   type="text"
                   class="form-control">
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <label>Telefone</label>
            <input v-model="mensalista.telefone"
                   v-mask="'(99) 9999-9999'"
                   type="text"
                   class="form-control"
                   placeholder="(99) 9999-99999">
          </div>
          <div class="col-2">
            <label>Celular <strong class="input-live-help">*</strong></label>
            <input v-model="mensalista.celular"
                   v-mask="'(99) 99999-9999'"
                   required
                   type="text"
                   class="form-control"
                   placeholder="(99) 9999-99999">
          </div>
          <div class="col-3">
            <label>Email <strong class="input-live-help">*</strong></label>
            <input v-model="mensalista.email"
                   required 
                   type="email"
                   class="form-control"
                   placeholder="email@email.com.br">
          </div>
          <div class="col-3">
            <label>Email de cobrança <strong class="input-live-help">*</strong></label>
            <input v-model="mensalista.email_cobranca"
                   required
                   type="email"
                   class="form-control"
                   placeholder="email@email.com.br">
          </div>
          <div class="col-2">
            <label>Dia de vencimento <strong class="input-live-help">*</strong></label>
            <b-form-select v-model="mensalista.dia_vencimento"
                           :options="selectsOptions.vencimento"
                           class="w-50" />
          </div>
        </div>
        <div class="row">
          <sub-header-grey class="pt-2 pb-2 pl-3 m-3 w-100">
            <label class="label-endereco">Endereço</label>
          </sub-header-grey>
        </div>
        <div class="row d-flex align-items-center">
          <div class="col-3">
            <label>CEP <strong class="input-live-help">*</strong></label>
            <b-form-input v-model="mensalista.endereco.cep"
                          v-mask="'99999-999'"
                          required
                          class="form-control"
                          name="cep"
                          :state="cepState"
                          placeholder="00000-000"
                          type="text"
                          @change="getCEP" />
            <b-form-invalid-feedback id="input-live-feedback">
              CEP não encontrado
            </b-form-invalid-feedback>
          </div>

          <div class="form-group">
            <button class="btn btn-sm btn-outline-primary mt-5"
                    variant=""
                    type="button"
                    @click="getCEP">
              Pesquisar CEP
            </button>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-6">
            <label for="endereco">Endereço <strong class="input-live-help">*</strong></label>
            <input id="endereco"
                   v-model="mensalista.endereco.logradouro"
                   required
                   type="text"
                   class="form-control"
                   placeholder="Rua Rattata Alola">
          </div>
          <div class="form-group col-2">
            <label for="numero">Número <strong class="input-live-help">*</strong></label>
            <b-form-input id="input-invalid"
                          ref="numero"
                          v-model="mensalista.endereco.numero"                          
                          required
                          type="text"
                          class="form-control"
                          placeholder="0000" />
          </div>
          <div class="form-group col-2">
            <label for="complemento">Complemento</label>
            <input id="complemento"
                   v-model="mensalista.endereco.complemento"
                   type="text"
                   class="form-control"
                   placeholder="Casa">
          </div>
        </div>
        <div class="row">
          <div class="form-group col-4">
            <label for="endereco">Bairro <strong class="input-live-help">*</strong></label>
            <input id="endereco"
                   v-model="mensalista.endereco.bairro"
                   required
                   type="text"
                   class="form-control"
                   placeholder="Tatuapé">
          </div>
          <div class="col-4 d-flex flex-column">
            <label>Cidade <strong class="input-live-help">*</strong></label>
            <b-form-select v-model="mensalista.endereco.cidade"
                           required
                           :options="selectsOptions.cidades.map((cidade)=>cidade.nome)"
                           class="w-100" />
          </div>
          <div class="col-2 d-flex flex-column">
            <label>Estado <strong class="input-live-help">*</strong></label>
            <b-form-select v-model="mensalista.endereco.uf"
                           required
                           :options="selectsOptions.states.map((state)=>state.uf)"
                           class="w-50" />
          </div>
        </div>
        <footer class="footer-mensalista">
          <b-button class="voltar-mensalista"
                    @click="fecharModal">
            Voltar
          </b-button>
          <b-button v-if="propMensalista === null"
                    class="adicionar-mensalista"
                    :disabled="btnSalvar"
                    type="submit">
            Adicionar
          </b-button>
          <b-button v-if="propMensalista != null"
                    class="adicionar-mensalista"
                    @click="editarMensalista">
            Editar
          </b-button>
        </footer>
      </Form>
    </b-modal>
  </div>
</template>

<script>
  // Componentes
  import SubHeaderGrey from "@/components/SofiaRei/Headers/SubHeaderGrey"

  // Services
  import EnderecosService from "@/services/Enderecos"
  import MensalistaService from "../mensalistaService"

  // Constantes
  import Cidades from "@/constants/repositorio/cidades"
  import BrazilianStates from "@/constants/brazilianStates"


  export default ({
    name: 'Mensalistas',
    components: {
      SubHeaderGrey
    },
    props: {
      propMensalista: {type: Object, default: null},
      propComponentePai: {type: String, default: null}
    },
    data () {
      return {
        mensalista: {
          cpf_cnpj: null,
          nome_empresa: null,
          telefone: null,
          celular: null,
          email: null,
          email_cobranca: null,
          dia_vencimento: 1,
          codigo_pais: null,
          exterior: null,
          endereco: {
            cep: "",
            ibge: '3550308',
            cidade: 'São Paulo',
            bairro: null,
            logradouro: null,
            uf: 'SP',
            numero: null,
            complemento: null,
          }
        },
        selectsOptions: {
          states: [...BrazilianStates],
          paises: [],
          cidades: [],
          vencimento: [1, 5, 10, 15, 20, 25],
        },
        validate: {
          numero: true,
          cep: null,
          cpf: null
        },
        btnSalvar: false
      }
    },
    computed: {
      cepState () {
        return this.validate.cep
      },
      cpfState () {
        return this.validate.cpf
      }
    },
    watch: {
      'mensalista.endereco.uf' () {
        const stateSelected = this.mensalista.endereco.uf

        if (stateSelected) {
          this.selectsOptions.cidades = Cidades.filter(cidade => cidade.uf === this.mensalista.endereco.uf)
        }
      },
    },
    async created () {
      // configura cidade e estado inicial
      const stateSelected = this.mensalista.endereco.uf
      if (stateSelected) {
        this.selectsOptions.cidades = Cidades.filter(cidade => cidade.uf == this.mensalista.endereco.uf)
      }
      // verifica se já existe um mensalista ou irá criar um novo
      this.initEdicao()
    },
    methods: {
      
      async getCEP () {
        if (!this.mensalista.endereco.cep) return

        loader({text: 'Buscando CEP', active: true})

        try {
          let data = await EnderecosService.getAddressByCEP(this.mensalista.endereco.cep)
          if (data.erro) {
            this.validate.cep = false
            return
          }
          this.validate.cep = true
          this.mensalista.endereco.ibge = data.ibge
          this.mensalista.endereco.cidade = data.localidade
          this.mensalista.endereco.uf = data.uf
          this.mensalista.endereco.logradouro = data.logradouro
          this.mensalista.endereco.complemento = data.complemento
          this.mensalista.endereco.bairro = data.bairro
          
          this.$refs.numero.focus()

          this.bvModal.hide('novoMensalista')
        } catch (err) {
          console.log(err)
        } finally {
          loader({active: false, text: null})
        }
      },
      async getCities () {
        const stateSelected = this.mensalista.endereco.uf

        if (stateSelected) {
          this.selectsOptions.cidades = Cidades.filter(cidade => cidade.uf == this.mensalista.endereco.uf)
        }
      },
      async salvarMensalista () {
        this.btnSalvar = true
        loader({text: 'Salvando mensalista', active: true})
        // Retira mascara de cpf antes de salvar
        const adapterCPF = this.mensalista.cpf_cnpj
          .replace('.', '')
          .replace('.', '')
          .replace('-', '')
          .replace('/', '')
        this.mensalista.cpf_cnpj = adapterCPF
        try {
          if (this.validate.cpf === false) {
            this.btnSalvar = false
            return displayMessage('error', 'Error!', 'Já existe um mensalista cadastrado com esse CPF/CNPJ. Altera as informações de CPF/CNPJ ou edite o mensalista caso haja algo errado com ele.')
          }
          const mensalista = await MensalistaService.storeMensalista(this.mensalista)
          this.atualizarLista()
          displayMessage('success', 'Mensalista cadastrado com sucesso')
          this.resetForm()
          this.$bvModal.hide('novoMensalista')
          this.$emit('mensalistaCriado', mensalista.data)
        } catch (err) {
          const data = getErrors(err)
          displayMessage('error', data.message)
            .then(() => this.fecharModal())
        } finally {
          this.btnSalvar = false
          loader({active: false, text: null})
        }
      },
      async editarMensalista () {
        loader({text: 'SalvanEditando mensalista', active: true})
        try {
          await MensalistaService.editarMensalista(this.mensalista)
          this.fecharModal()
          this.atualizarLista()
          displayMessage('success', 'Mensalista editado com sucesso')
        } catch (err) {
          const data = getErrors(err)
          displayMessage('error', data.message)
            .then(() => this.fecharModal())
        } finally {
          loader({text: null, active: false})
        }
      },
      async validaCPF () {
        if (this.mensalista.cpf_cnpj.length < 1) return this.validate.cpf = null
        const adapterCPF = this.mensalista.cpf_cnpj
          .replace('.', '')
          .replace('.', '')
          .replace('-', '')
          .replace('/', '')
        // verifica se já existe um mensalista com esse CPF ou CNPJ
        try {
          loader({text: 'Salvando mensalista', active: true})
          const mensalista = await MensalistaService.validaCPF(adapterCPF)
          if (mensalista.length > 0) {
            return this.validate.cpf = false
          }
          this.validate.cpf = true
        } catch (err) {
          console.log(err)
        } finally {
          loader({active: false, text: null})
        }
      },
      fecharModal () {
        if (this.propMensalista) {
          return this.$bvModal.hide(`novoMensalista${this.propMensalista.mensalista_id}`)
        }
        this.resetForm()
        this.$bvModal.hide('novoMensalista')
      },
      resetForm () {
        Object.assign(this.$data, this.$options.data())
      },
      showModal () {
        if (this.propMensalista) {
          return this.$bvModal.show(`novoMensalista${this.propMensalista.mensalista_id}`)
        }
        this.$bvModal.show('novoMensalista')
      },
      initEdicao () {
        if (this.propMensalista != null) {
          this.mensalista = {
            mensalista_id: this.propMensalista.mensalista_id,
            cpf_cnpj: this.propMensalista.cpf_cnpj,
            nome_empresa: this.propMensalista.nome_empresa,
            telefone: this.propMensalista.telefone,
            celular: this.propMensalista.celular,
            email: this.propMensalista.email,
            email_cobranca: this.propMensalista.email_cobranca,
            dia_vencimento: this.propMensalista.dia_vencimento,
            codigo_pais: this.propMensalista.codigo_pais,
            exterior: this.propMensalista.exterior,
            endereco: {
              cep: this.propMensalista.cep,
              ibge: this.propMensalista.ibge,
              cidade: this.propMensalista.cidade,
              bairro: this.propMensalista.bairro,
              logradouro: this.propMensalista.logradouro,
              uf: this.propMensalista.uf,
              numero: this.propMensalista.numero,
              complemento: this.propMensalista.complemento,
            }
          }
        }
      },
      async atualizarLista () {
        try {
          // Pega os mensalistas para listar e distribuir
          loader ({text: 'Buscando Mensalistas', active: true})
          const mensalistas = await MensalistaService.getMensalistas()
          this.$store.dispatch('frenteCaixa/atualizarMensalistas', mensalistas)
        } catch (err) {
          console.log('Mensalista', err)
        } finally {
          loader ({text: null, active: false})
        }
      }
    }
  })
</script>

<style scoped>
.add-icon {
    fill: white;
    height: 30px;
    width: 20px;
}
.icon-simple-pecil {
  fill: gray;
  height: 40px;
  width: 45px;
}
.label-endereco {
  font-size: 18px;
}
.footer-mensalista {
  display: flex;
  justify-content: end;
  gap: 20px;
  padding-top: 20px;
  margin-top: 30px;
  border-top: #1E4C89 1px solid;
}
.voltar-mensalista {
  background-color: #C6C6C6;
  border-color: #C6C6C6;
  color: black;
  padding: 8px 30px 8px 30px;
}
.adicionar-mensalista {
  border: none;
  padding: 8px 30px 8px 30px;
}
.input-live-help {
  color: red;
}
</style>